import React from "react";

export default function CameraViewPage(props) {
  return (
    <>Camera View Page</>
  );
}